<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size"  viewBox="0 0 40 40">
  <g id="Group_24" data-name="Group 24" transform="translate(8.361 7.293)">
    <circle id="Ellipse_41" data-name="Ellipse 41" cx="20" cy="20" r="20" transform="translate(-8.361 -7.293)" fill="currentColor"/>
    <path id="Path_32" data-name="Path 32" d="M2052.531-475.3a11.619,11.619,0,0,0-10.859-7.653,11.619,11.619,0,0,0-10.86,7.653h-.778v2.209h23.276V-475.3Zm-10.859-5.737a9.7,9.7,0,0,1,8.758,5.631h-17.516A9.7,9.7,0,0,1,2041.671-481.036Z" transform="translate(-2030.033 482.952)" fill="#fff"/>
    <path id="Path_33" data-name="Path 33" d="M2050.428-464.4h-1.969v9.421h-3.2V-464.4h-1.968v9.421h-3.2V-464.4h-1.969v9.421h-3.2V-464.4h-1.969v9.421h-2.93v2.086h23.276v-2.086h-2.881Z" transform="translate(-2030.033 475.279)" fill="#fff"/>
  </g>
</svg>

</template>

<script>
export default {
  'name': 'RegimeIcon',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/RegimeIcon.vue